module.exports = __webpack_public_path__ + "img/hr-decider-combinator.8d121f8d.png";